/*
    General Helper Class
*/

// example: https://bithacker.dev/javascript-object-multi-property-sort

import StorageService from "@Vytelle/admin/src/services/StorageService";

import LOCALIZATION from "@Vytelle/admin/src/services/LocalizationService";

// Components
import { saveAs } from "file-saver";
import { useTimezoneSelect, allTimezones } from "react-timezone-select";

// Config
import {
  COMMON_API_BASE_URL,
  DAQ_API_BASE_URL,
} from "@Vytelle/admin/src/config/environment";

// Constants
import { API_URLS_COMMON } from "@Vytelle/admin/src/constants/ApiUrlCommon";
import ReactStorageService from "@Vytelle/admin/src/services/StorageService";

export const getBaseUrl = (url) => {
  let flag = false;
  Object.values(API_URLS_COMMON).forEach((el) => {
    if (!flag && url?.includes(el) && url.slice(0, 2) === el.slice(0, 2)) {
      flag = true;
    }
  });

  return flag ? COMMON_API_BASE_URL : DAQ_API_BASE_URL;
};

export const getName = () => {
  const { firstName, fullName } = StorageService.instance.getUserInfo() || {};

  return firstName || fullName;
};

export const getUsername = () => {
  const {  fullName } = StorageService.instance.getUserInfo() || {};

  return fullName;
};

export const getRole = (appId, roleId = false) => {
  const { applicationRole } = StorageService.instance.getUserInfo();
  const appInfo = applicationRole.find((app) => app.application.id === appId);
  return roleId ? appInfo?.role?.id : appInfo?.role?.name;
};

export const parseJwt = (token) => {
  var base64Url = token?.split(".")[1];
  var base64 = base64Url?.replace(/-/g, "+")?.replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export const disabledFutureDates = (current) => {
  return current && current.valueOf() > Date.now();
};

// Sort an array
export function sortArray(array = [], sortBy) {
  return (
    array &&
    array?.sort(function (a, b) {
      let i = 0,
        result = 0;
      while (i < sortBy.length && result === 0) {
        result =
          sortBy[i].direction *
          (a[sortBy[i]?.prop]?.toString() < b[sortBy[i]?.prop]?.toString()
            ? -1
            : a[sortBy[i]?.prop]?.toString() > b[sortBy[i]?.prop]?.toString()
            ? 1
            : 0);
        i++;
      }
      return result;
    })
  );
}

export function truncateString(str, n) {
  if (str?.length > n) {
    return str.substring(0, n) + "...";
  } else {
    return str;
  }
}

export function camalize(str) {
  const words = str.split(" ");

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0]?.toUpperCase() + words[i]?.substr(1).toLowerCase();
  }

  return words.join(" ");
}

// Get Int value of given value
export function getIntVal(value) {
  return parseInt(value || 0);
}

// Add Thousand Separator in value
export function thousandSeprator(x) {
  return x.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const toBase64 = async (file) => {
  const action = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
  const base64String = await action;
  let result = base64String?.split(",")?.[1];
  return result;
};

export function getFiltersCount(filterObj = {}) {
  let count = 0;
  filterObj &&
    // eslint-disable-next-line array-callback-return
    Object.keys(filterObj)?.map((key) => {
      const value = filterObj?.[key];
      const isArray = Array.isArray(value);
      if ((!isArray && !!value) || (!!isArray && !!value?.length > 0)) {
        count++;
      }
    });
  return count;
}

export function isObjectEmpty(obj) {
  return (
    !!obj &&
    !!!Object.keys(obj)
      ?.map((key) => !!obj?.[key])
      ?.filter((i) => i !== false)?.length
  );
}

export function getRecordValue(data, key, parent, lookUpValue, LookupArr) {
  let value = "";
  value =
    !!parent && !!data?.[parent]?.[key]
      ? data[parent][key]
      : data[key] !== undefined && data[key] !== null
      ? data[key]
      : LOCALIZATION.NA;
  value = !lookUpValue ? value : getLookUpValues(LookupArr, value);
  // if (value && value !== LOCALIZATION.NA) {        // To DO : will implement this section when we will have date formats
  //   switch (type) {
  //     case DATA_TYPES.DATE:
  //       return format(new Date(value), DATE_FORMAT.MONTH_DAY_YEAR);
  //     default:
  //       return value;
  //   }
  // }
  return value;
}

export function getRecordMultipleValues(arr, key, parentKey) {
  const result = arr?.map((obj) =>
    !!parentKey ? obj?.[parentKey]?.[key] : obj?.[key]
  );
  return result;
}

// check for empty obj
export function checkObjIsEmpty(obj) {
  return !Object.keys(obj).length;
}

// get dropdown values
export function getDropdownData(list=[], value, text) {
  if (!list) {
    return [];
  }

  let data = [];
  for (let i = 0; i < list?.length; i++) {
    data.push({
      value: list?.[i]?.[value],
      name: list?.[i]?.[text],
      ...(list[i].id && { id: list[i].id + "" }),
    });
  }
  return data;
}

export function compareTwoValues(val1, val2) {
  return val1 === val2;
}

export function compareArrays(arr1, arr2) {
  if (arr1?.length === arr2?.length) {
    var areEqual = arr1.every(function (element, index) {
      return element === arr2[index];
    });
    return areEqual;
  } else {
    if (
      (arr1 === undefined && arr2.length === 0) ||
      (arr2 === undefined && arr1.length === 0)
    ) {
      return true;
    }
    return false;
  }
}

// compare 2 objects
export function compareObjects(obj1, obj2, keys) {
  for (let key of keys) {
    const val1 = obj1?.[key];
    const val2 = obj2?.[key];
    const result =
      Array.isArray(val1) || Array.isArray(val2)
        ? compareArrays(val1, val2)
        : compareTwoValues(val1, val2);
    if (!result) {
      return false;
    }
  }
  return true;
}

// get error message
export function getErrorMessage(e, defaultMessage = LOCALIZATION.ACTON_FAILED) {
  const errors = e?.response?.data?.errors;
  const errorMessage = [defaultMessage];
  if (
    !!errors &&
    ((Array.isArray(errors) && !!errors?.length) || !Array.isArray(errors))
  ) {
    return errors;
  } else {
    return errorMessage;
  }
}

// breadcrumb formatting
export function breadcrumbFormating(breadcrumbArr, constArr) {
  const replacedBreadcrumbArr = breadcrumbArr.map((item) => {
    let replacedItem = { ...item }; // Create a copy of the item object

    // Iterate over the constArr to replace the keywords
    constArr.forEach((replacement) => {
      const [keyword, value] = replacement;

      // Replace the keyword in the title and link properties
      replacedItem.title = replacedItem?.title?.replace(keyword, value);
      replacedItem.link = replacedItem?.link?.replace(`:${keyword}`, value);
    });

    return replacedItem;
  });

  return replacedBreadcrumbArr;
}

// count days between two dates
export function differenceBetweenTwoDates(d1, d2) {
  const date1 = new Date(d1);
  const date2 = new Date(d2);

  // Calculate the time difference in milliseconds
  const timeDiff = date1.getTime() - date2.getTime();

  // Convert milliseconds to days
  const count = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

  return count;
}

export function generateDropdownNumberList(minValue, maxValue) {
  if (!minValue || !maxValue) {
    return [];
  }

  const data = [];
  for (let i = minValue; i <= maxValue; i++) {
    data.push({
      value: i,
      name: `${i}`,
    });
  }
  return data;
}

export function getLookUpValues(arr, value) {
  const obj = arr?.filter((item) => item?.code === value);
  return obj?.[0]?.value || LOCALIZATION.NA;
}

export function getPlaceholder(placeholder) {
  return `Select ${placeholder?.toLowerCase()}`;
}

export function truncateToTwoDecimalPlaces(n) {
  let value = 0;
  if (!!n) {
    value = n = Math.floor(parseFloat(n) * 100) / 100; // truncating values after 2 decimal places without rounding
  }
  return value;
}

export function setGivenDecimalPlaces(form, key, n) {
  if (!!n) {
    n = truncateToTwoDecimalPlaces(n);
    form.setFieldsValue({
      [key]: n,
    });
  }
}

export function truncateDigits(n, allowedDigits, precision = 0) {
  if (!n) {
    return;
  }
  // Convert the number to a string to handle decimal places
  const numStr = n?.toString();

  // Split the string into integer and decimal parts
  const [integerPart, decimalPart] = numStr?.split(".");
  const integerTruncatedValue = integerPart?.substring(0, allowedDigits);
  let decimalTuncatedValue = null;
  if (!!decimalPart && !!precision) {
    decimalTuncatedValue = decimalPart?.substring(0, precision);
  }
  const finalValue =
    integerTruncatedValue +
    (!!decimalTuncatedValue ? "." + decimalTuncatedValue : "");
  return parseFloat(finalValue);
}

export function setDataToTruncatedValue(
  form,
  key,
  n,
  allowedDigits,
  precision = 0
) {
  if (!!n) {
    n = truncateDigits(n, allowedDigits, precision);
    form.setFieldsValue({
      [key]: n,
    });
  }
}

export function getRoleByApplication(
  applicationRoles = [],
  currentApplication = 0
) {
  const roleObject = applicationRoles?.filter(
    (object) => object?.application?.id === currentApplication
  );

  return roleObject?.length !== 0 ? roleObject[0]?.role?.name : null;
}

// download file
export function downloadReport(
  response,
  name = LOCALIZATION.DEFAULT_FILENAME + LOCALIZATION.DEFAULT_EXTENSION
) {
  // get filename from response received if exists
  let filename =
    response?.headers?.["content-disposition"]
      ?.split(";")
      ?.find((n) => n?.includes("filename="))
      ?.replace(" filename=", "")
      ?.trim()
      ?.replace(/['"]+/g, "") || name;

  var blob = new Blob([response], { type: LOCALIZATION.BLOB_TYPE });
  saveAs(blob, filename);
}

// Get weight unit
export function getWeightUnit() {
  const appPref = ReactStorageService.instance.getAppPreference();
  // If KG is 2
  return appPref.weightUnit === 2 ? LOCALIZATION.KG : LOCALIZATION.LB;
}

// Convert KG to Lbs
export function getWeightUnitValue(kgAmount = 0) {
  const appPref = ReactStorageService.instance.getAppPreference();
  // Checking if unit is Kg
  if (appPref.weightUnit === 2) {
    if (Number.isInteger(kgAmount)) return `${kgAmount} ${LOCALIZATION.KG}`;
    else return `${kgAmount?.toFixed(1)} ${LOCALIZATION.KG}`;
  }
  // Checking if unit is Lbs
  const poundBase = kgAmount * 2.20462;
  if (Number.isInteger(poundBase)) return `${poundBase} ${LOCALIZATION.LB}`;
  else return `${poundBase.toFixed(1)} ${LOCALIZATION.LB}`;
}

// Convert KG to Lbs
export function convertWeightUnitValue(lbsValue = 0) {
  const appPref = ReactStorageService.instance.getAppPreference();
  // Checking if unit is Kg
  if (appPref.weightUnit === 2) {
    if (Number.isInteger(lbsValue)) return lbsValue;
    else return lbsValue.toFixed(1);
  }
  // Checking if unit is Lbs
  const kgValue = lbsValue / 2.20462;
  if (Number.isInteger(kgValue)) return kgValue;
  else return kgValue.toFixed(1);
}

// convert given weight according to settings
export function getConvertedUnitValue(kgAmount = 0, appendUnit = false) {
  kgAmount = Math.round(kgAmount * 100) / 100;
  const appPref = ReactStorageService.instance.getAppPreference(); // Checking if unit is Kg
  if (appPref.weightUnit === 2) {
    return appendUnit ? `${kgAmount} ${LOCALIZATION.KG}` : kgAmount;
  } // Checking if unit is Lbs
  const poundBase = Math.round(kgAmount * 2.20462 * 100) / 100;
  return appendUnit ? `${poundBase} ${LOCALIZATION.LB}` : poundBase;
}

/**
 * A functions that takes params as a parameter and returns an filter object
 */
export const persistFilters = (params) => {
  const { sortKey, orderBy, pageNumber, pageSize, searchText, ...filterState } =
    params;
  const formatFilters = {
    filters: { ...filterState },
    sort: {
      key: sortKey,
      order: orderBy,
    },
    pagination: {
      pageNumber,
      pageSize,
    },
    searchText,
  };
  return formatFilters;
};

export const useExtendedTimeZoneLabel = (timeZone = null) => {
  const labelStyle = "original";
  const { options, parseTimezone } = useTimezoneSelect({
    labelStyle,
    allTimezones,
  });
  const timeZoneLabel = (options || []).filter((obj) => obj.value === timeZone);
  return !!timeZoneLabel?.length
    ? `(GMT ${timeZoneLabel?.[0]?.offset < 0 ? '' : '+'}${timeZoneLabel?.[0]?.offset || 0}) ${timeZoneLabel[0].value}`
    : timeZone;
};
